function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    width: "60px",
    height: "60px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD600"
    },
    d: "M6,42V6h36v36H6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000001"
    },
    d: "M29.538,32.947c0.692,1.124,1.444,2.201,3.037,2.201c1.338,0,2.04-0.665,2.04-1.585  c0-1.101-0.726-1.492-2.198-2.133l-0.807-0.344c-2.329-0.988-3.878-2.226-3.878-4.841c0-2.41,1.845-4.244,4.728-4.244  c2.053,0,3.528,0.711,4.592,2.573l-2.514,1.607c-0.553-0.988-1.151-1.377-2.078-1.377c-0.946,0-1.545,0.597-1.545,1.377  c0,0.964,0.6,1.354,1.985,1.951l0.807,0.344C36.452,29.645,38,30.839,38,33.523C38,36.415,35.716,38,32.65,38  c-2.999,0-4.702-1.505-5.65-3.368L29.538,32.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000001"
    },
    d: "M17.952,33.029c0.506,0.906,1.275,1.603,2.381,1.603c1.058,0,1.667-0.418,1.667-2.043V22h3.333  v11.101c0,3.367-1.953,4.899-4.805,4.899c-2.577,0-4.437-1.746-5.195-3.368L17.952,33.029z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.0616f27b30a327e8b8d0076a12a3cf63.svg";
export { ForwardRef as ReactComponent };